import { render, staticRenderFns } from "./FormRoedores.vue?vue&type=template&id=273e287c&scoped=true"
import script from "./FormRoedores.vue?vue&type=script&lang=js"
export * from "./FormRoedores.vue?vue&type=script&lang=js"
import style0 from "./FormRoedores.vue?vue&type=style&index=0&id=273e287c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273e287c",
  null
  
)

export default component.exports